import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

const GET_TRANSFER_ARCHIVE_BY_CLIENT = gql`
  query transferarchives($clientId: ObjectId!, $tenantId: ObjectId!) {
    transferarchives(
      query: { client: { _id: $clientId }, tenant: { _id: $tenantId } }
    ) {
      _id
      firstName
      middleName
      lastName
      otherIndividuals
      email
      mobilePhone
      propertyAddress1
      propertyAddress2
      propertyCity
      propertyState
      propertyZipcode
      amount
      fee
      purpose
      expectedClosingDate_utc
      sellerName
      notes
      status
      disbursement
      active
      createdAt_utc
      purpose
      completedOn_utc
      clearedOn_utc

      tenant {
        _id
        name
        address1
        address2
        city
        state
        zipcode
      }
      client {
        _id
        firstName
        lastName
        address1
        address2
        city
        state
        zipcode
        propertyAddress1
        propertyAddress2
        propertyCity
        propertyState
        propertyZipcode
      }
      transferType {
        _id
        name
        isDebit
        isCredit
        purpose
      }
      sourceBankAccount {
        _id
        bankName
        description
        accountLastFourDigits
        bankDisplayName
        active
        client {
          _id
        }
        institutionCode
        updatedAt_utc
      }
      destBankAccount {
        _id
        bankName
        description
        accountLastFourDigits
        bankDisplayName
        active
        client {
          _id
        }
        institutionCode
        updatedAt_utc
      }
      agent {
        _id
        firstName
        lastName
        email
      }
      realtor {
        _id
        firstName
        lastName
        email
      }
      updatedAt_utc
    }
  }
`;

export default function useTransferArchiveByClientId(clientId, tenantId) {
  const { loading, error, refetch, data } = useQuery(
    GET_TRANSFER_ARCHIVE_BY_CLIENT,
    {
      variables: { clientId, tenantId },
      fetchPolicy: 'no-cache',
    },
  );

  return {
    loadingArchive: loading,
    error,
    refetch,
    transferArchives: data ? data.transferarchives : undefined,
  };
}
